export async function bridgeLibraryRequest(queue, path, method, body, raw) {
  const match = /^\/(shelf|wishlist)(?:\/(-?\d+))?$/.exec(path.split("?")[0]);
  if (match && method !== "GET") {
    await queue.ready;
    const kind = match[1],
      row = match[2]
        ? queue.find(kind, Number(match[2]))
        : queue.lookup(kind, body.category, body.external_id);
    if (match[2] && !row)
      throw Error("Сначала загрузите библиотеку при подключении к интернету");
    const result = await queue.mutate(
      kind,
      method === "DELETE" ? "remove" : method === "POST" ? "add" : "update",
      row,
      body,
    );
    return { handled: true, value: result };
  }
  if (path === "/ratings" && method === "POST") {
    await queue.ready;
    let row = queue.lookup("rating", body.category, body.external_id);
    if (!row) {
      const library =
        queue.lookup("shelf", body.category, body.external_id) ||
        queue.lookup("wishlist", body.category, body.external_id);
      if (library)
        row = {
          rating: library.user_rating ?? null,
          category: body.category,
          external_id: String(body.external_id),
          _absent: library.user_rating == null,
        };
    }
    if (!row) {
      const value = await raw(
        `/ratings/${body.category}/${encodeURIComponent(body.external_id)}`,
        { method: "GET" },
      );
      row = {
        ...value,
        category: body.category,
        external_id: String(body.external_id),
        _absent: value.rating === null,
      };
      queue.observe("rating", row);
    }
    return {
      handled: true,
      value: await queue.mutate("rating", "update", row, {
        rating: body.rating,
        category: body.category,
        external_id: body.external_id,
      }),
    };
  }
  return { handled: false };
}
export function observeLibraryResponse(queue, path, value, ticket) {
  const kind = /^\/(shelf|wishlist)(?:\?|$)/.exec(path)?.[1];
  if (kind && Array.isArray(value)) {
    if (ticket != null && ticket !== queue.getState().revision)
      return queue.snapshot(kind);
    queue.observe(kind, value);
    return queue.overlay(kind, value);
  }
  const rating = /^\/ratings\/(film|series|game|music|book)\/([^/?]+)$/.exec(
    path,
  );
  if (rating && value && "rating" in value) {
    if (ticket != null && ticket !== queue.getState().revision) {
      const known = queue.lookup(
        "rating",
        rating[1],
        decodeURIComponent(rating[2]),
      );
      if (known) return { ...value, ...known };
    }
    queue.observe("rating", {
      ...value,
      external_id: decodeURIComponent(rating[2]),
      category: rating[1],
      _absent: value.rating === null,
    });
    const pending = queue
      .overlay("rating", [])
      .find(
        (row) =>
          row.category === rating[1] &&
          String(row.external_id) === decodeURIComponent(rating[2]),
      );
    if (pending) return { ...value, rating: pending.rating, _pending: true };
  }
  return value;
}
